export const dataHeidelbeere = {
  id: 'heidelbeere',
  title: 'Heidelbeere',
  content: [
    {
      year: 1940,
      rot: {
        term: 'Blaubeere',
      },
      blau: {
        term: 'Heidelbeer',
      },
      gelb: {
        term: 'Höip(b)eri',
      },
      text: (
        <div>
          <p>text</p>
        </div>
      ),
      mapData: [
        {
          site_code: 'AG01',
          dom_var: 'Höip(b)eri',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'AG02',
          dom_var: 'Höip(b)eri',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'AG03',
          dom_var: 'Höip(b)eri',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'AG04',
          dom_var: 'Höip(b)eri',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'AG05',
          dom_var: 'Höip(b)eri',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'AG06',
          dom_var: 'Höip(b)eri',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'AG07',
          dom_var: 'Höip(b)eri',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'AG08',
          dom_var: 'Höip(b)eri',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'AG09',
          dom_var: 'Höip(b)eri',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'AG10',
          dom_var: 'Höip(b)eri',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'AG11',
          dom_var: 'Höip(b)eri',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'AI01',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'AR01',
          dom_var: 'andere/Heidelbeer',
          nvar: 2,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'AR02',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'BE01',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'BE02',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'BE03',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'BE04',
          dom_var: 'andere/Höip(b)eri',
          nvar: 2,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'BE05',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'BE06',
          dom_var: 'Höip(b)eri',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BE07',
          dom_var: 'andere/Höip(b)eri',
          nvar: 2,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'BE08',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'BE09',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'BE10',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'BE11',
          dom_var: 'Höip(b)eri',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BE12',
          dom_var: 'Höip(b)eri',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BE13',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'BE14',
          dom_var: 'Höip(b)eri',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BE15',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'BE16',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'BE17',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'BE18',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'BE19',
          dom_var: 'Höip(b)eri',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BE20',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'BE21',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'BE22',
          dom_var: 'Höip(b)eri',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BE23',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'BE24',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'BE25',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'BL01',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BL02',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BL03',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BL04',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BL05',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BS01',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'FR01',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'FR02',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'FR03',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'FR04',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'FR05',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'FR06',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'GL01',
          dom_var: 'Blaubeere/Höip(b)eri',
          nvar: 2,
          andereBegriffe: '',
        },
        {
          site_code: 'GL02',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'GR01',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'GR02',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'GR03',
          dom_var: 'Höip(b)eri',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'GR04',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'GR05',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'GR06',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'GR07',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'GR08',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'GR09',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'LU01',
          dom_var: 'Höip(b)eri',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'LU02',
          dom_var: 'Höip(b)eri',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'LU03',
          dom_var: 'Höip(b)eri',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'LU04',
          dom_var: 'Höip(b)eri',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'LU05',
          dom_var: 'Höip(b)eri',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'LU06',
          dom_var: 'Höip(b)eri',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'NW01',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'OW01',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'OW02',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'OW03',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'SG01',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'SG02',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SG03',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SG04',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'SG05',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SG06',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SG07',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'SG08',
          dom_var: 'andere/Heidelbeer',
          nvar: 2,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'SG09',
          dom_var: 'Höip(b)eri',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SG10',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SG11',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SG12',
          dom_var: 'andere/Heidelbeer',
          nvar: 2,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'SH01',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SH02',
          dom_var: 'Höip(b)eri',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SO01',
          dom_var: 'Höip(b)eri',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SO02',
          dom_var: 'Höip(b)eri',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SO03',
          dom_var: 'andere/Höip(b)eri',
          nvar: 2,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'SO04',
          dom_var: 'Höip(b)eri',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SZ01',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SZ02',
          dom_var: 'andere/Blaubeere',
          nvar: 2,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'SZ03',
          dom_var: 'Höip(b)eri',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SZ04',
          dom_var: 'Höip(b)eri',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SZ05',
          dom_var: 'Blaubeere/Höip(b)eri',
          nvar: 2,
          andereBegriffe: '',
        },
        {
          site_code: 'TG01',
          dom_var: 'andere/Heidelbeer',
          nvar: 2,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'TG02',
          dom_var: 'andere/Heidelbeer',
          nvar: 2,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'TG03',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'TG04',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'TG05',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'TG06',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'TI01',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'UR01',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'UR02',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'UR03',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'VS01',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'VS02',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'VS03',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'VS04',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'VS05',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'VS06',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'VS07',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'VS08',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'VS09',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'VS10',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'VS11',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Haselb-, Häselb-, Häslib-, Heeti, Heiteb-, Heiti, Heitu, Hööti',
        },
        {
          site_code: 'ZG01',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'ZG02',
          dom_var: 'Höip(b)eri',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'ZH01',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'ZH02',
          dom_var: 'Höip(b)eri',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'ZH03',
          dom_var: 'Höip(b)eri',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'ZH04',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'ZH05',
          dom_var: 'Höip(b)eri',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'ZH06',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'ZH07',
          dom_var: 'Höip(b)eri',
          nvar: 1,
          andereBegriffe: '',
        },
      ],
    },
    {
      year: 2020,
      rot: {
        term: 'Blaubeere',
      },
      blau: {
        term: 'Heidelbeer',
      },
      gelb: {
        term: 'Höip(b)eri',
      },
      text: (
        <div>
          <p>text</p>
        </div>
      ),
      mapData: [
        {
          site_code: 'AG01',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'AG02',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'AG03',
          dom_var: 'Blaubeere/Heidelbeer',
          nvar: 2,
          andereBegriffe: '',
        },
        {
          site_code: 'AG04',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'AG05',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'AG06',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'AG07',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'AG08',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'AG09',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'AG10',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'AG11',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'AI01',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Blueberry, Häipe(e)ri, Häselbei, Heeti, Heiper, Heite, Heitebe(e)ri, Heiti, Hinteberi, Hööti, Hünti, Rtil',
        },
        {
          site_code: 'AR01',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'AR02',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BE01',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Blueberry, Häipe(e)ri, Häselbei, Heeti, Heiper, Heite, Heitebe(e)ri, Heiti, Hinteberi, Hööti, Hünti, Rtil',
        },
        {
          site_code: 'BE02',
          dom_var: 'andere/Blaubeere',
          nvar: 2,
          andereBegriffe:
            'Ber(r)i, Blueberry, Häipe(e)ri, Häselbei, Heeti, Heiper, Heite, Heitebe(e)ri, Heiti, Hinteberi, Hööti, Hünti, Rtil',
        },
        {
          site_code: 'BE03',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BE04',
          dom_var: 'Blaubeere/Heidelbeer',
          nvar: 2,
          andereBegriffe: '',
        },
        {
          site_code: 'BE05',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BE06',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BE07',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BE08',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Blueberry, Häipe(e)ri, Häselbei, Heeti, Heiper, Heite, Heitebe(e)ri, Heiti, Hinteberi, Hööti, Hünti, Rtil',
        },
        {
          site_code: 'BE09',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Blueberry, Häipe(e)ri, Häselbei, Heeti, Heiper, Heite, Heitebe(e)ri, Heiti, Hinteberi, Hööti, Hünti, Rtil',
        },
        {
          site_code: 'BE10',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Blueberry, Häipe(e)ri, Häselbei, Heeti, Heiper, Heite, Heitebe(e)ri, Heiti, Hinteberi, Hööti, Hünti, Rtil',
        },
        {
          site_code: 'BE11',
          dom_var: 'Höip(b)eri',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BE12',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BE13',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BE14',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BE15',
          dom_var: 'Höip(b)eri',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BE16',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Blueberry, Häipe(e)ri, Häselbei, Heeti, Heiper, Heite, Heitebe(e)ri, Heiti, Hinteberi, Hööti, Hünti, Rtil',
        },
        {
          site_code: 'BE17',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Blueberry, Häipe(e)ri, Häselbei, Heeti, Heiper, Heite, Heitebe(e)ri, Heiti, Hinteberi, Hööti, Hünti, Rtil',
        },
        {
          site_code: 'BE18',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Blueberry, Häipe(e)ri, Häselbei, Heeti, Heiper, Heite, Heitebe(e)ri, Heiti, Hinteberi, Hööti, Hünti, Rtil',
        },
        {
          site_code: 'BE19',
          dom_var: 'andere/Blaubeere/Heidelbeer/Höip(b)eri',
          nvar: 4,
          andereBegriffe:
            'Ber(r)i, Blueberry, Häipe(e)ri, Häselbei, Heeti, Heiper, Heite, Heitebe(e)ri, Heiti, Hinteberi, Hööti, Hünti, Rtil',
        },
        {
          site_code: 'BE20',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Blueberry, Häipe(e)ri, Häselbei, Heeti, Heiper, Heite, Heitebe(e)ri, Heiti, Hinteberi, Hööti, Hünti, Rtil',
        },
        {
          site_code: 'BE21',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Blueberry, Häipe(e)ri, Häselbei, Heeti, Heiper, Heite, Heitebe(e)ri, Heiti, Hinteberi, Hööti, Hünti, Rtil',
        },
        {
          site_code: 'BE22',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BE23',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Blueberry, Häipe(e)ri, Häselbei, Heeti, Heiper, Heite, Heitebe(e)ri, Heiti, Hinteberi, Hööti, Hünti, Rtil',
        },
        {
          site_code: 'BE24',
          dom_var: 'andere/Heidelbeer',
          nvar: 2,
          andereBegriffe:
            'Ber(r)i, Blueberry, Häipe(e)ri, Häselbei, Heeti, Heiper, Heite, Heitebe(e)ri, Heiti, Hinteberi, Hööti, Hünti, Rtil',
        },
        {
          site_code: 'BE25',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Blueberry, Häipe(e)ri, Häselbei, Heeti, Heiper, Heite, Heitebe(e)ri, Heiti, Hinteberi, Hööti, Hünti, Rtil',
        },
        {
          site_code: 'BL01',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BL02',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BL03',
          dom_var: 'Blaubeere/Heidelbeer',
          nvar: 2,
          andereBegriffe: '',
        },
        {
          site_code: 'BL04',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BL05',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BS01',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'FR01',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Blueberry, Häipe(e)ri, Häselbei, Heeti, Heiper, Heite, Heitebe(e)ri, Heiti, Hinteberi, Hööti, Hünti, Rtil',
        },
        {
          site_code: 'FR02',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'FR03',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Blueberry, Häipe(e)ri, Häselbei, Heeti, Heiper, Heite, Heitebe(e)ri, Heiti, Hinteberi, Hööti, Hünti, Rtil',
        },
        {
          site_code: 'FR04',
          dom_var: 'andere/Blaubeere',
          nvar: 2,
          andereBegriffe:
            'Ber(r)i, Blueberry, Häipe(e)ri, Häselbei, Heeti, Heiper, Heite, Heitebe(e)ri, Heiti, Hinteberi, Hööti, Hünti, Rtil',
        },
        {
          site_code: 'FR05',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'FR06',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Blueberry, Häipe(e)ri, Häselbei, Heeti, Heiper, Heite, Heitebe(e)ri, Heiti, Hinteberi, Hööti, Hünti, Rtil',
        },
        {
          site_code: 'GL01',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'GL02',
          dom_var: 'Blaubeere/Heidelbeer',
          nvar: 2,
          andereBegriffe: '',
        },
        {
          site_code: 'GR01',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'GR02',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'GR03',
          dom_var: 'Höip(b)eri',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'GR04',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'GR05',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'GR06',
          dom_var: 'Höip(b)eri',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'GR07',
          dom_var: 'Blaubeere/Heidelbeer',
          nvar: 2,
          andereBegriffe: '',
        },
        {
          site_code: 'GR08',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'GR09',
          dom_var: 'andere/Heidelbeer',
          nvar: 2,
          andereBegriffe:
            'Ber(r)i, Blueberry, Häipe(e)ri, Häselbei, Heeti, Heiper, Heite, Heitebe(e)ri, Heiti, Hinteberi, Hööti, Hünti, Rtil',
        },
        {
          site_code: 'LU01',
          dom_var: 'Höip(b)eri',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'LU02',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'LU03',
          dom_var: 'Höip(b)eri',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'LU04',
          dom_var: 'Höip(b)eri',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'LU05',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'LU06',
          dom_var: 'Höip(b)eri',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'NW01',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'OW01',
          dom_var: 'Höip(b)eri',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'OW02',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'OW03',
          dom_var: 'Höip(b)eri',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SG01',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SG02',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SG03',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SG04',
          dom_var: 'Blaubeere/Heidelbeer',
          nvar: 2,
          andereBegriffe: '',
        },
        {
          site_code: 'SG05',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SG06',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SG07',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SG08',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SG09',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SG10',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SG11',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SG12',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SH01',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SH02',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SO01',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SO02',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SO03',
          dom_var: 'Blaubeere/Heidelbeer',
          nvar: 2,
          andereBegriffe: '',
        },
        {
          site_code: 'SO04',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SZ01',
          dom_var: 'Blaubeere/Heidelbeer',
          nvar: 2,
          andereBegriffe: '',
        },
        {
          site_code: 'SZ02',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SZ03',
          dom_var: 'Höip(b)eri',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SZ04',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SZ05',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'TG01',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'TG02',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'TG03',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'TG04',
          dom_var: 'Blaubeere/Heidelbeer',
          nvar: 2,
          andereBegriffe: '',
        },
        {
          site_code: 'TG05',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'TG06',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'TI01',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Blueberry, Häipe(e)ri, Häselbei, Heeti, Heiper, Heite, Heitebe(e)ri, Heiti, Hinteberi, Hööti, Hünti, Rtil',
        },
        {
          site_code: 'UR01',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'UR02',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'UR03',
          dom_var: 'andere/Heidelbeer',
          nvar: 2,
          andereBegriffe:
            'Ber(r)i, Blueberry, Häipe(e)ri, Häselbei, Heeti, Heiper, Heite, Heitebe(e)ri, Heiti, Hinteberi, Hööti, Hünti, Rtil',
        },
        {
          site_code: 'VS01',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Blueberry, Häipe(e)ri, Häselbei, Heeti, Heiper, Heite, Heitebe(e)ri, Heiti, Hinteberi, Hööti, Hünti, Rtil',
        },
        {
          site_code: 'VS02',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Blueberry, Häipe(e)ri, Häselbei, Heeti, Heiper, Heite, Heitebe(e)ri, Heiti, Hinteberi, Hööti, Hünti, Rtil',
        },
        {
          site_code: 'VS03',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Blueberry, Häipe(e)ri, Häselbei, Heeti, Heiper, Heite, Heitebe(e)ri, Heiti, Hinteberi, Hööti, Hünti, Rtil',
        },
        {
          site_code: 'VS04',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'VS05',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Blueberry, Häipe(e)ri, Häselbei, Heeti, Heiper, Heite, Heitebe(e)ri, Heiti, Hinteberi, Hööti, Hünti, Rtil',
        },
        {
          site_code: 'VS06',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'VS07',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Blueberry, Häipe(e)ri, Häselbei, Heeti, Heiper, Heite, Heitebe(e)ri, Heiti, Hinteberi, Hööti, Hünti, Rtil',
        },
        {
          site_code: 'VS08',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Blueberry, Häipe(e)ri, Häselbei, Heeti, Heiper, Heite, Heitebe(e)ri, Heiti, Hinteberi, Hööti, Hünti, Rtil',
        },
        {
          site_code: 'VS09',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'VS10',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Blueberry, Häipe(e)ri, Häselbei, Heeti, Heiper, Heite, Heitebe(e)ri, Heiti, Hinteberi, Hööti, Hünti, Rtil',
        },
        {
          site_code: 'VS11',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'ZG01',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'ZG02',
          dom_var: 'Blaubeere/Heidelbeer',
          nvar: 2,
          andereBegriffe: '',
        },
        {
          site_code: 'ZH01',
          dom_var: 'Blaubeere/Heidelbeer',
          nvar: 2,
          andereBegriffe: '',
        },
        {
          site_code: 'ZH02',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'ZH03',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'ZH04',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'ZH05',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'ZH06',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'ZH07',
          dom_var: 'Blaubeere/Heidelbeer',
          nvar: 2,
          andereBegriffe: '',
        },
      ],
    },
    {
      year: 2060,
      rot: {
        term: 'Blaubeere',
      },
      blau: {
        term: 'Heidelbeer',
      },
      gelb: {
        term: 'Höip(b)eri',
      },
      text: (
        <div>
          <p>text</p>
        </div>
      ),
      mapData: [
        {
          site_code: 'AG01',
          dom_var: 'Höip(b)eri',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'AG02',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'AG03',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'AG04',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'AG05',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'AG06',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'AG07',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'AG08',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'AG09',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'AG10',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'AG11',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'AI01',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'AR01',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'AR02',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BE01',
          dom_var: 'Blaubeere/Heidelbeer',
          nvar: 2,
          andereBegriffe: '',
        },
        {
          site_code: 'BE02',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ber(r)i, Blueberry, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Häipe(e)ri, Haselb-, Häselb-, Haselbei, Häselbei, Häslib-, Häslibei(er), Heeti, Heeti, Heiper, Heite, Heiteb-, Heitebe(e)ri, Heiti, Heiti, Heitu, Hinteberi, Hööti, Hööti, Hünti, Palodere, Palöögele, Rtil, Schwarz',
        },
        {
          site_code: 'BE03',
          dom_var: 'Blaubeere/Heidelbeer',
          nvar: 2,
          andereBegriffe: '',
        },
        {
          site_code: 'BE04',
          dom_var: 'Blaubeere/Heidelbeer',
          nvar: 2,
          andereBegriffe: '',
        },
        {
          site_code: 'BE05',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BE06',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BE07',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BE08',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ber(r)i, Blueberry, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Häipe(e)ri, Haselb-, Häselb-, Haselbei, Häselbei, Häslib-, Häslibei(er), Heeti, Heeti, Heiper, Heite, Heiteb-, Heitebe(e)ri, Heiti, Heiti, Heitu, Hinteberi, Hööti, Hööti, Hünti, Palodere, Palöögele, Rtil, Schwarz',
        },
        {
          site_code: 'BE09',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ber(r)i, Blueberry, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Häipe(e)ri, Haselb-, Häselb-, Haselbei, Häselbei, Häslib-, Häslibei(er), Heeti, Heeti, Heiper, Heite, Heiteb-, Heitebe(e)ri, Heiti, Heiti, Heitu, Hinteberi, Hööti, Hööti, Hünti, Palodere, Palöögele, Rtil, Schwarz',
        },
        {
          site_code: 'BE10',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ber(r)i, Blueberry, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Häipe(e)ri, Haselb-, Häselb-, Haselbei, Häselbei, Häslib-, Häslibei(er), Heeti, Heeti, Heiper, Heite, Heiteb-, Heitebe(e)ri, Heiti, Heiti, Heitu, Hinteberi, Hööti, Hööti, Hünti, Palodere, Palöögele, Rtil, Schwarz',
        },
        {
          site_code: 'BE11',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BE12',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BE13',
          dom_var: 'Blaubeere/Heidelbeer',
          nvar: 2,
          andereBegriffe: '',
        },
        {
          site_code: 'BE14',
          dom_var: 'Blaubeere/Heidelbeer',
          nvar: 2,
          andereBegriffe: '',
        },
        {
          site_code: 'BE15',
          dom_var: 'Blaubeere/Heidelbeer',
          nvar: 2,
          andereBegriffe: '',
        },
        {
          site_code: 'BE16',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ber(r)i, Blueberry, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Häipe(e)ri, Haselb-, Häselb-, Haselbei, Häselbei, Häslib-, Häslibei(er), Heeti, Heeti, Heiper, Heite, Heiteb-, Heitebe(e)ri, Heiti, Heiti, Heitu, Hinteberi, Hööti, Hööti, Hünti, Palodere, Palöögele, Rtil, Schwarz',
        },
        {
          site_code: 'BE17',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ber(r)i, Blueberry, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Häipe(e)ri, Haselb-, Häselb-, Haselbei, Häselbei, Häslib-, Häslibei(er), Heeti, Heeti, Heiper, Heite, Heiteb-, Heitebe(e)ri, Heiti, Heiti, Heitu, Hinteberi, Hööti, Hööti, Hünti, Palodere, Palöögele, Rtil, Schwarz',
        },
        {
          site_code: 'BE18',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BE19',
          dom_var: 'Blaubeere/Heidelbeer',
          nvar: 2,
          andereBegriffe: '',
        },
        {
          site_code: 'BE20',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ber(r)i, Blueberry, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Häipe(e)ri, Haselb-, Häselb-, Haselbei, Häselbei, Häslib-, Häslibei(er), Heeti, Heeti, Heiper, Heite, Heiteb-, Heitebe(e)ri, Heiti, Heiti, Heitu, Hinteberi, Hööti, Hööti, Hünti, Palodere, Palöögele, Rtil, Schwarz',
        },
        {
          site_code: 'BE21',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ber(r)i, Blueberry, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Häipe(e)ri, Haselb-, Häselb-, Haselbei, Häselbei, Häslib-, Häslibei(er), Heeti, Heeti, Heiper, Heite, Heiteb-, Heitebe(e)ri, Heiti, Heiti, Heitu, Hinteberi, Hööti, Hööti, Hünti, Palodere, Palöögele, Rtil, Schwarz',
        },
        {
          site_code: 'BE22',
          dom_var: 'Blaubeere/Heidelbeer',
          nvar: 2,
          andereBegriffe: '',
        },
        {
          site_code: 'BE23',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BE24',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ber(r)i, Blueberry, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Häipe(e)ri, Haselb-, Häselb-, Haselbei, Häselbei, Häslib-, Häslibei(er), Heeti, Heeti, Heiper, Heite, Heiteb-, Heitebe(e)ri, Heiti, Heiti, Heitu, Hinteberi, Hööti, Hööti, Hünti, Palodere, Palöögele, Rtil, Schwarz',
        },
        {
          site_code: 'BE25',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ber(r)i, Blueberry, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Häipe(e)ri, Haselb-, Häselb-, Haselbei, Häselbei, Häslib-, Häslibei(er), Heeti, Heeti, Heiper, Heite, Heiteb-, Heitebe(e)ri, Heiti, Heiti, Heitu, Hinteberi, Hööti, Hööti, Hünti, Palodere, Palöögele, Rtil, Schwarz',
        },
        {
          site_code: 'BL01',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BL02',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BL03',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BL04',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BL05',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BS01',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'FR01',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ber(r)i, Blueberry, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Häipe(e)ri, Haselb-, Häselb-, Haselbei, Häselbei, Häslib-, Häslibei(er), Heeti, Heeti, Heiper, Heite, Heiteb-, Heitebe(e)ri, Heiti, Heiti, Heitu, Hinteberi, Hööti, Hööti, Hünti, Palodere, Palöögele, Rtil, Schwarz',
        },
        {
          site_code: 'FR02',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ber(r)i, Blueberry, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Häipe(e)ri, Haselb-, Häselb-, Haselbei, Häselbei, Häslib-, Häslibei(er), Heeti, Heeti, Heiper, Heite, Heiteb-, Heitebe(e)ri, Heiti, Heiti, Heitu, Hinteberi, Hööti, Hööti, Hünti, Palodere, Palöögele, Rtil, Schwarz',
        },
        {
          site_code: 'FR03',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ber(r)i, Blueberry, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Häipe(e)ri, Haselb-, Häselb-, Haselbei, Häselbei, Häslib-, Häslibei(er), Heeti, Heeti, Heiper, Heite, Heiteb-, Heitebe(e)ri, Heiti, Heiti, Heitu, Hinteberi, Hööti, Hööti, Hünti, Palodere, Palöögele, Rtil, Schwarz',
        },
        {
          site_code: 'FR04',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ber(r)i, Blueberry, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Häipe(e)ri, Haselb-, Häselb-, Haselbei, Häselbei, Häslib-, Häslibei(er), Heeti, Heeti, Heiper, Heite, Heiteb-, Heitebe(e)ri, Heiti, Heiti, Heitu, Hinteberi, Hööti, Hööti, Hünti, Palodere, Palöögele, Rtil, Schwarz',
        },
        {
          site_code: 'FR05',
          dom_var: 'Blaubeere/Heidelbeer',
          nvar: 2,
          andereBegriffe: '',
        },
        {
          site_code: 'FR06',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ber(r)i, Blueberry, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Häipe(e)ri, Haselb-, Häselb-, Haselbei, Häselbei, Häslib-, Häslibei(er), Heeti, Heeti, Heiper, Heite, Heiteb-, Heitebe(e)ri, Heiti, Heiti, Heitu, Hinteberi, Hööti, Hööti, Hünti, Palodere, Palöögele, Rtil, Schwarz',
        },
        {
          site_code: 'GL01',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'GL02',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'GR01',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'GR02',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'GR03',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ber(r)i, Blueberry, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Häipe(e)ri, Haselb-, Häselb-, Haselbei, Häselbei, Häslib-, Häslibei(er), Heeti, Heeti, Heiper, Heite, Heiteb-, Heitebe(e)ri, Heiti, Heiti, Heitu, Hinteberi, Hööti, Hööti, Hünti, Palodere, Palöögele, Rtil, Schwarz',
        },
        {
          site_code: 'GR04',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'GR05',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ber(r)i, Blueberry, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Häipe(e)ri, Haselb-, Häselb-, Haselbei, Häselbei, Häslib-, Häslibei(er), Heeti, Heeti, Heiper, Heite, Heiteb-, Heitebe(e)ri, Heiti, Heiti, Heitu, Hinteberi, Hööti, Hööti, Hünti, Palodere, Palöögele, Rtil, Schwarz',
        },
        {
          site_code: 'GR06',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ber(r)i, Blueberry, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Häipe(e)ri, Haselb-, Häselb-, Haselbei, Häselbei, Häslib-, Häslibei(er), Heeti, Heeti, Heiper, Heite, Heiteb-, Heitebe(e)ri, Heiti, Heiti, Heitu, Hinteberi, Hööti, Hööti, Hünti, Palodere, Palöögele, Rtil, Schwarz',
        },
        {
          site_code: 'GR07',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ber(r)i, Blueberry, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Häipe(e)ri, Haselb-, Häselb-, Haselbei, Häselbei, Häslib-, Häslibei(er), Heeti, Heeti, Heiper, Heite, Heiteb-, Heitebe(e)ri, Heiti, Heiti, Heitu, Hinteberi, Hööti, Hööti, Hünti, Palodere, Palöögele, Rtil, Schwarz',
        },
        {
          site_code: 'GR08',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'GR09',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ber(r)i, Blueberry, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Häipe(e)ri, Haselb-, Häselb-, Haselbei, Häselbei, Häslib-, Häslibei(er), Heeti, Heeti, Heiper, Heite, Heiteb-, Heitebe(e)ri, Heiti, Heiti, Heitu, Hinteberi, Hööti, Hööti, Hünti, Palodere, Palöögele, Rtil, Schwarz',
        },
        {
          site_code: 'LU01',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'LU02',
          dom_var: 'Höip(b)eri',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'LU03',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'LU04',
          dom_var: 'Höip(b)eri',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'LU05',
          dom_var: 'Blaubeere/Heidelbeer',
          nvar: 2,
          andereBegriffe: '',
        },
        {
          site_code: 'LU06',
          dom_var: 'Höip(b)eri',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'NW01',
          dom_var: 'Blaubeere/Heidelbeer',
          nvar: 2,
          andereBegriffe: '',
        },
        {
          site_code: 'OW01',
          dom_var: 'Blaubeere/Heidelbeer',
          nvar: 2,
          andereBegriffe: '',
        },
        {
          site_code: 'OW02',
          dom_var: 'Blaubeere/Heidelbeer',
          nvar: 2,
          andereBegriffe: '',
        },
        {
          site_code: 'OW03',
          dom_var: 'Blaubeere/Heidelbeer',
          nvar: 2,
          andereBegriffe: '',
        },
        {
          site_code: 'SG01',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SG02',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SG03',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SG04',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SG05',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SG06',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SG07',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SG08',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SG09',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SG10',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SG11',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SG12',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SH01',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SH02',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SO01',
          dom_var: 'Blaubeere/Heidelbeer',
          nvar: 2,
          andereBegriffe: '',
        },
        {
          site_code: 'SO02',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SO03',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SO04',
          dom_var: 'Blaubeere/Heidelbeer',
          nvar: 2,
          andereBegriffe: '',
        },
        {
          site_code: 'SZ01',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SZ02',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SZ03',
          dom_var: 'Blaubeere/Heidelbeer',
          nvar: 2,
          andereBegriffe: '',
        },
        {
          site_code: 'SZ04',
          dom_var: 'Blaubeere/Heidelbeer',
          nvar: 2,
          andereBegriffe: '',
        },
        {
          site_code: 'SZ05',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'TG01',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'TG02',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'TG03',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'TG04',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'TG05',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'TG06',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'TI01',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ber(r)i, Blueberry, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Häipe(e)ri, Haselb-, Häselb-, Haselbei, Häselbei, Häslib-, Häslibei(er), Heeti, Heeti, Heiper, Heite, Heiteb-, Heitebe(e)ri, Heiti, Heiti, Heitu, Hinteberi, Hööti, Hööti, Hünti, Palodere, Palöögele, Rtil, Schwarz',
        },
        {
          site_code: 'UR01',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'UR02',
          dom_var: 'Blaubeere/Heidelbeer',
          nvar: 2,
          andereBegriffe: '',
        },
        {
          site_code: 'UR03',
          dom_var: 'Blaubeere/Heidelbeer',
          nvar: 2,
          andereBegriffe: '',
        },
        {
          site_code: 'VS01',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ber(r)i, Blueberry, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Häipe(e)ri, Haselb-, Häselb-, Haselbei, Häselbei, Häslib-, Häslibei(er), Heeti, Heeti, Heiper, Heite, Heiteb-, Heitebe(e)ri, Heiti, Heiti, Heitu, Hinteberi, Hööti, Hööti, Hünti, Palodere, Palöögele, Rtil, Schwarz',
        },
        {
          site_code: 'VS02',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ber(r)i, Blueberry, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Häipe(e)ri, Haselb-, Häselb-, Haselbei, Häselbei, Häslib-, Häslibei(er), Heeti, Heeti, Heiper, Heite, Heiteb-, Heitebe(e)ri, Heiti, Heiti, Heitu, Hinteberi, Hööti, Hööti, Hünti, Palodere, Palöögele, Rtil, Schwarz',
        },
        {
          site_code: 'VS03',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ber(r)i, Blueberry, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Häipe(e)ri, Haselb-, Häselb-, Haselbei, Häselbei, Häslib-, Häslibei(er), Heeti, Heeti, Heiper, Heite, Heiteb-, Heitebe(e)ri, Heiti, Heiti, Heitu, Hinteberi, Hööti, Hööti, Hünti, Palodere, Palöögele, Rtil, Schwarz',
        },
        {
          site_code: 'VS04',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ber(r)i, Blueberry, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Häipe(e)ri, Haselb-, Häselb-, Haselbei, Häselbei, Häslib-, Häslibei(er), Heeti, Heeti, Heiper, Heite, Heiteb-, Heitebe(e)ri, Heiti, Heiti, Heitu, Hinteberi, Hööti, Hööti, Hünti, Palodere, Palöögele, Rtil, Schwarz',
        },
        {
          site_code: 'VS05',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ber(r)i, Blueberry, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Häipe(e)ri, Haselb-, Häselb-, Haselbei, Häselbei, Häslib-, Häslibei(er), Heeti, Heeti, Heiper, Heite, Heiteb-, Heitebe(e)ri, Heiti, Heiti, Heitu, Hinteberi, Hööti, Hööti, Hünti, Palodere, Palöögele, Rtil, Schwarz',
        },
        {
          site_code: 'VS06',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ber(r)i, Blueberry, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Häipe(e)ri, Haselb-, Häselb-, Haselbei, Häselbei, Häslib-, Häslibei(er), Heeti, Heeti, Heiper, Heite, Heiteb-, Heitebe(e)ri, Heiti, Heiti, Heitu, Hinteberi, Hööti, Hööti, Hünti, Palodere, Palöögele, Rtil, Schwarz',
        },
        {
          site_code: 'VS07',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ber(r)i, Blueberry, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Häipe(e)ri, Haselb-, Häselb-, Haselbei, Häselbei, Häslib-, Häslibei(er), Heeti, Heeti, Heiper, Heite, Heiteb-, Heitebe(e)ri, Heiti, Heiti, Heitu, Hinteberi, Hööti, Hööti, Hünti, Palodere, Palöögele, Rtil, Schwarz',
        },
        {
          site_code: 'VS08',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'VS09',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'VS10',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ber(r)i, Blueberry, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Häipe(e)ri, Haselb-, Häselb-, Haselbei, Häselbei, Häslib-, Häslibei(er), Heeti, Heeti, Heiper, Heite, Heiteb-, Heitebe(e)ri, Heiti, Heiti, Heitu, Hinteberi, Hööti, Hööti, Hünti, Palodere, Palöögele, Rtil, Schwarz',
        },
        {
          site_code: 'VS11',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ber(r)i, Blueberry, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Häipe(e)ri, Haselb-, Häselb-, Haselbei, Häselbei, Häslib-, Häslibei(er), Heeti, Heeti, Heiper, Heite, Heiteb-, Heitebe(e)ri, Heiti, Heiti, Heitu, Hinteberi, Hööti, Hööti, Hünti, Palodere, Palöögele, Rtil, Schwarz',
        },
        {
          site_code: 'ZG01',
          dom_var: 'Blaubeere/Heidelbeer',
          nvar: 2,
          andereBegriffe: '',
        },
        {
          site_code: 'ZG02',
          dom_var: 'Höip(b)eri',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'ZH01',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'ZH02',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'ZH03',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'ZH04',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'ZH05',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'ZH06',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'ZH07',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
      ],
    },
    {
      year: 2100,
      rot: {
        term: 'Blaubeere',
      },
      blau: {
        term: 'Heidelbeer',
      },
      gelb: {
        term: 'Höip(b)eri',
      },
      text: (
        <div>
          <p>text</p>
        </div>
      ),
      mapData: [
        {
          site_code: 'AG01',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'AG02',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'AG03',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'AG04',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'AG05',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'AG06',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'AG07',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'AG08',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'AG09',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'AG10',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'AG11',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'AI01',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'AR01',
          dom_var: 'Blaubeere/Heidelbeer',
          nvar: 2,
          andereBegriffe: '',
        },
        {
          site_code: 'AR02',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BE01',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BE02',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BE03',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BE04',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BE05',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BE06',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BE07',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BE08',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BE09',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BE10',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BE11',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BE12',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BE13',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BE14',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BE15',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BE16',
          dom_var: 'andere',
          nvar: 1,
          andereBegriffe:
            'Ber(r)i, Ber(r)i, Blueberry, Ha(a)deb-, Ha(a)delb-, Häipe(e)ri, Häipe(e)ri, Haselb-, Häselb-, Haselbei, Häselbei, Häslib-, Häslibei(er), Heeti, Heeti, Heiper, Heite, Heiteb-, Heitebe(e)ri, Heiti, Heiti, Heitu, Hinteberi, Hööti, Hööti, Hünti, Palodere, Palöögele, Rtil, Schwarz',
        },
        {
          site_code: 'BE17',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BE18',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BE19',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BE20',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BE21',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BE22',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BE23',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BE24',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BE25',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BL01',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BL02',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BL03',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BL04',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BL05',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'BS01',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'FR01',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'FR02',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'FR03',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'FR04',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'FR05',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'FR06',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'GL01',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'GL02',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'GR01',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'GR02',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'GR03',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'GR04',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'GR05',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'GR06',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'GR07',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'GR08',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'GR09',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'LU01',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'LU02',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'LU03',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'LU04',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'LU05',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'LU06',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'NW01',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'OW01',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'OW02',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'OW03',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SG01',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SG02',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SG03',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SG04',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SG05',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SG06',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SG07',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SG08',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SG09',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SG10',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SG11',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SG12',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SH01',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SH02',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SO01',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SO02',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SO03',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SO04',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SZ01',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SZ02',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SZ03',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SZ04',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'SZ05',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'TG01',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'TG02',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'TG03',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'TG04',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'TG05',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'TG06',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'TI01',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'UR01',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'UR02',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'UR03',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'VS01',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'VS02',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'VS03',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'VS04',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'VS05',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'VS06',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'VS07',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'VS08',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'VS09',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'VS10',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'VS11',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'ZG01',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'ZG02',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'ZH01',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'ZH02',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'ZH03',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'ZH04',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'ZH05',
          dom_var: 'Heidelbeer',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'ZH06',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
        {
          site_code: 'ZH07',
          dom_var: 'Blaubeere',
          nvar: 1,
          andereBegriffe: '',
        },
      ],
    },
  ],
}
